module.exports = __webpack_public_path__ + "static/banner-mobile-687fcfb1e1f30392c3d4419dd39d3e2f.svg";